(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        
        //for sticky header top distance
        let headerLogoEle = this.header.querySelector('sticky-header > header');
        if(headerLogoEle){
          let eleHeight = headerLogoEle.offsetHeight;
          document.querySelector('.shopify-section-header-sticky').style.top = `-${eleHeight}px;`
        }
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    

  const create_customer_form = document.querySelector('form#create_customer');
  if(create_customer_form){
    const submitBtn = create_customer_form.querySelector('[data-form-submit]');
    if(submitBtn){
      submitBtn.addEventListener('click', function(evt){
        evt.preventDefault();
        validateForm(create_customer_form);
      });
    }
  }

  function validateForm(form){
    if(!form) return;
    const requiredFormField = [...form.querySelectorAll('input[required]')];
    let errorCount = 0;
    if(requiredFormField.length){
      requiredFormField.forEach(field => {
        const fieldValue = field.value.trim();
        const fieldType = field.getAttribute('type');
        field.closest('.field-grp').classList.remove('error-active');
        if(!fieldValue.length){
          field.closest('.field-grp').classList.add('error-active');
          errorCount += 1;
        }else if(fieldType == 'email'){
          const isValidEmail = validateEmail(field.value.trim(),field);
          if(!isValidEmail) errorCount += 1;
        }else if(fieldType == 'password'){
          let password_val = form.querySelector('#RegisterForm-password').value.trim();
          let confirm_password_val = form.querySelector('#RegisterForm-confirm-password').value.trim();
          if(password_val != confirm_password_val){
            errorCount += 1;
            field.getAttribute('id') == 'RegisterForm-confirm-password' ? field.closest('.field-grp').classList.add('error-active') : null;
          }
        }
      });
    }
    if(errorCount === 0){
     form.submit();
    }else{
      return false;
    }
  }

  function validateEmail(value,field) {
    //let mailRegularExpresion = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value);
    let mailRegularExpression = /^[a-zA-Z0-9._#%+\-!$&'*\/=?^`{|}~]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return mailRegularExpression.test(value);
    field.closest('.field-grp').classList.add('error-active');
  }

  } catch(e) { console.error(e); }
})();
})();
